import { render } from "./SystemMessages.vue?vue&type=template&id=b3e71f22&scoped=true"
import script from "./SystemMessages.vue?vue&type=script&lang=js"
export * from "./SystemMessages.vue?vue&type=script&lang=js"

import "./SystemMessages.vue?vue&type=style&index=0&id=b3e71f22&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3e71f22"]])

export default __exports__